<template>

  <div class="home">
    <div class="home-box">
      <div class="banner pointer" v-if="bannerList && bannerList.length>0">
        <el-carousel height="320px" :interval="5000" arrow="always">
          <el-carousel-item
            v-for="item in bannerList"
            :key="item.bannercode"
            >
            <img @click="handleNavigate(item)" :src="item.mynameimg" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="content pt20 pb20">
        <div class="latest" v-if="latestShowList.length">
          <div class="title">
            <div class="left-btn">最近演出</div>
          </div>
          <div class="latest-content dfac">
            <div
              v-for="(item, index) in latestShowList"
              :key="index"
              class="latest-item p20 pointer"
              @click="handleNavigate(item)">
              <div class="poster">
                <img :src="item.poster || require('@/assets/img/no-img.jpg')" alt=""/>
                <div v-if="item.showSoldOutFlag == 1" class="sell-out">售罄</div>
              </div>
              <p class="ellipsis2 mt10 fs14 tl" style="min-height: 28px;line-height: 20px;">{{item.proname}}</p>
              <p class="fs12 tl fc9 mt10">{{item.probegdate}}-{{item.proenddate}}</p>
              <p class="fcMain tr mt10"><span class="fs18">￥{{item.minsellprice}}</span>起</p>
            </div>
          </div>
        </div>
        <div
          v-for="(item, index) in typeList"
          :key="index"
          class="mt30 type">
          <div class="title">
            <div class="left-btn">{{item.typename}}</div>
            <div class="right-btn pointer" @click="handleCheckAll(item.typename)">查看全部</div>
          </div>
          <div v-if="item.projects.length<5" class="df">
            <div
              v-for="(item1, index) in item.projects"
              :key="index"
              class="type-item1 df p10 pointer"
              @click="handleNavigate(item1)">
              <img :src="item1.poster || require('@/assets/img/no-img.jpg')" alt="">
              <div>
                <div>
                  <p class="ellipsis2 fs14 tl" style="min-height: 28px;line-height: 20px;">{{item1.proname}}</p>
                  <p class="fs12 tl fc9 mt10">{{item1.probegdate}}-{{item1.proenddate}}</p>
                  <p class="fs12 tl fc9 mt10">{{item1.theatername}}</p>
                </div>
                <p class="fcMain tr mt10"><span class="fs18">￥{{item1.minsellprice}}</span>起</p>
              </div>
            </div>
          </div>
          <div class="type-content dfacjsb" v-else>
            <div
              @click="handleNavigate(item.projects[0])"
              class="type-item2-first pointer"
              :style="{background:'url('+(item.projects[0].poster ? item.projects[0].poster : require('@/assets/img/no-img.jpg'))+') no-repeat center'}">
              <div class="tl fs16 df">
                <p class="ellipsis2">{{item.projects[0].proname}}</p>
                <p>￥{{item.projects[0].minsellprice}}<span class="fs14">起</span></p>
              </div>
            </div>
            <div class="type-item2-others-box df flex-wrap">
              <div
                v-for="(item1, index) in item.projects.slice(1)"
                :key="index"
                class="type-item2-others df pointer"
                @click="handleNavigate(item1)">
                <div class="poster">
                  <img :src="item1.poster || require('@/assets/img/no-img.jpg')" alt="">
                  <div v-if="item1.showSoldOutFlag == 1" class="sell-out">售罄</div>
                </div>
                <div class="info">
                  <div>
                    <p class="ellipsis2 fs14 tl" style="min-height: 28px;line-height: 20px;">{{item1.proname}}</p>
                    <p class="fs12 tl fc9 mt10">{{item1.probegdate}}-{{item1.proenddate}}</p>
                    <p class="fs12 tl fc9 mt10">{{item1.theatername}}</p>
                  </div>
                  <p class="fcMain tr mt10"><span class="fs18">￥{{item1.minsellprice}}</span>起</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer/index.vue';
import {
  api_banner,
  api_projectList,
  api_projectTypeBrowseList
} from '@/api/home';
export default {
  name: "MyHome",
  components: {
    Footer
  },
  data() {
    return {
      bannerList: [],
      latestShowList: [],
      typeList: []
    };
  },
  mounted() {
    this.getBanner()
    this.getLatestShow()
    this.getTypeShow()
  },
  methods: {
    getBanner() {
      const params = {
        groupcode: this.$store.state.user.groupcode
      }
      api_banner(params).then(res => {
        if (res.code == '0') {
          this.bannerList = res.data
        }
      })
    },
    getLatestShow() {
      const params = {
        groupcode: this.$store.state.user.groupcode
      }
      api_projectList(params).then(res => {
        if (res.code == '0') {
          this.latestShowList = res.data.length > 5 ? res.data.slice(0, 5) : res.data
        }
      })
    },
    getTypeShow() {
      const params = {
        groupcode: this.$store.state.user.groupcode
      }
      api_projectTypeBrowseList(params).then(res => {
        if (res.code == '0') {
          this.typeList = res.data
        }
      })
    },
    handleNavigate(item) {
      if ((item.jumptype && item.jumptype != '0') || (item.jumptype && item.jumptype == '0' && !item.procode)) return
      this.$router.push({
        name: 'ShowDetail',
        query: {code: item.procode, appselltype: item.appselltype}
      })
    },
    handleCheckAll(typename) {
      this.$router.push({
        name: 'AllShow',
        query: { typename }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background: white;
  margin-top: 10px; 
  
  .home-box {
    width: 1200px;
    margin: 0 auto;

    .banner {
      img {
        width: 100%;
        height: 100%;
      }
    }

    .content {
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
        font-size: 16px;

        .left-btn {
          // width: 150px;
          // height: 40px;
          // background: #ddd;
          // border-radius: 40px;
          // line-height: 40px;
          font-size: 24px;
        }

        .right-btn {
          width: 114px;
          height: 40px;
          line-height: 40px;
          background: #fff;
          color: #9b9b9b;
          font-size: 14px;
        }
      }

      .latest, .type {
        border: 1px solid #ebebeb;
        padding: 20px;
      }

      .latest .latest-content {

        &>div {
          width: 225px;
          background: #fff;
          border-radius: 8px;
          margin-right: 20px;
          .poster{
            width: 100%;
            height: 226px;
            position: relative;
            .sell-out {
              position: absolute;
              right: 0;
              top: 0;
              // transform: translate(-50%, -50%) rotate(-10deg);
              background-color: rgba(0, 0, 0, 0.5);
              font-size: 12px;
              padding: 4px 12px;
              color: #fff;
            }
          }
          img {
            width: 100%;
            height: 100%;
          }
        }

        &>div:last-child {
          margin-right: 0;
        }

        .latest-item {
          border: 1px solid #ededed;
        }

        .latest-item:hover {
          box-shadow: 0 0 10px grey;
        }
      }

      .type {
        .type-item1 {
          width: 285px;
          height: 176px;
          background: #fff;
          margin-right: 20px;

          img {
            width: 120px;
            height: 100%;
          }

          &>div {
            padding-left: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
        }

        .type-item1:last-child {
          margin-right: 0;
        }

        .type-content {
          height: 360px;
          flex-wrap: wrap;

          .type-item2 {
            height: 100%;
          }

          .type-item2-first {
            width: 270px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: end;

            &>div {
              height: 120px;
              width: 100%;
              background: rgba(black, 0.3);
              color: white;
              padding: 20px 10px;
              flex-direction: column;
              justify-content: space-between;
            }
          }

          .type-item2-others-box {
            width: 870px;
            height: 100%;
          }

          .type-item2-others {
            height: 163px;
            width: 270px;
            background: #fff;
            margin-right: 10px;
            margin-bottom: 34px;
            padding: 0 10px;
            .poster{
              width: 118px;
              height: 100%;
              position: relative;
              .sell-out {
                position: absolute;
                right: 0;
                top: 0;
                // transform: translate(-50%, -50%) rotate(-10deg);
                background-color: rgba(0, 0, 0, 0.5);
                font-size: 12px;
                padding: 4px 12px;
                color: #fff;
              }
            }
            img {
              width: 100%;
              height: 100%;
            }

            .info {
              padding-left: 15px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              flex: 1;
            }
          }

          .type-item2-others:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>

